"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es6.reflect.construct.js");

require("core-js/modules/es6.symbol.js");

require("core-js/modules/es6.string.iterator.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.array.iterator.js");

require("core-js/modules/web.dom.iterable.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.slice.js");

require("core-js/modules/es6.function.name.js");

require("core-js/modules/es6.array.map.js");

require("core-js/modules/es6.array.find.js");

require("core-js/modules/es6.object.set-prototype-of.js");

require("core-js/modules/es6.object.get-prototype-of.js");

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("../../../lib/utils");

var _reactRouter = require("react-router");

var _InfoWindow = _interopRequireDefault(require("./InfoWindow"));

var _blackSpeechBubbleIcon = _interopRequireDefault(require("@evdy/web-share/src/images/black-speech-bubble-icon.svg"));

require("../../../sass/components/shared/elements/UserWelcome.css");

var _CharacterProfileImage = _interopRequireDefault(require("../../shared/elements/CharacterProfileImage"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var UserWelcome = /*#__PURE__*/function (_React$Component) {
  _inherits(UserWelcome, _React$Component);

  var _super = _createSuper(UserWelcome);

  function UserWelcome(props) {
    var _this;

    _classCallCheck(this, UserWelcome);

    _this = _super.call(this, props);
    _this.toggleArrow = _this.toggleArrow.bind(_assertThisInitialized(_this));
    _this.state = {
      rotate: false
    };
    return _this;
  }

  _createClass(UserWelcome, [{
    key: "toggleArrow",
    value: function toggleArrow() {
      (0, _utils.googleAnalytics)('header_menu');
      this.setState({
        rotate: !this.state.rotate
      });
    }
  }, {
    key: "infoWindowToggle",
    value: function infoWindowToggle(e) {
      this.infoWindow.infoWindowToggle();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
          _user;

      var _this$props = this.props,
          inbox = _this$props.inbox,
          isDemo = _this$props.isDemo,
          openSignUpModal = _this$props.openSignUpModal,
          setMobileMenu = _this$props.setMobileMenu,
          handleSignOut = _this$props.handleSignOut,
          unreadCount = _this$props.unreadCount,
          pathname = _this$props.pathname;
      var user = this.props.user;
      var hasCompany = user && !!user.company;
      var slicedInbox = inbox && inbox.slice(0, 5) || [];
      var windowClasses = (0, _classnames.default)('profile-drop', {
        rotate: this.state.rotate
      });
      var messagesLinkClasses = (0, _classnames.default)({
        'header-messages-link': true,
        'new-messages': isDemo || unreadCount
      });
      var menuLinksClasses = (0, _classnames.default)({
        'menu-links': true
      });
      isDemo && (user = {
        name: {
          first: 'Alex',
          last: 'Smith'
        }
      });
      var emailToShow = user.email || user.shellEmail;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "header-user-welcome"
      }, /*#__PURE__*/_react.default.createElement(_InfoWindow.default, {
        isDemo: isDemo,
        openSignUpModal: openSignUpModal,
        noClose: true,
        outsideTextClass: "hi",
        outsideText: "Hi ".concat(user.name && user.name.first),
        windowClass: windowClasses,
        onClick: this.toggleArrow,
        ref: function ref(el) {
          return _this2.infoWindow = el;
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "menu-user-info"
      }, /*#__PURE__*/_react.default.createElement(_CharacterProfileImage.default, {
        image: user.image,
        name: (_user = user) === null || _user === void 0 ? void 0 : _user.name
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "name-email"
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "user-name"
      }, (0, _utils.nameString)(user.name), " ", /*#__PURE__*/_react.default.createElement("span", {
        className: "arrow"
      })), emailToShow && /*#__PURE__*/_react.default.createElement("p", {
        className: "user-email"
      }, emailToShow))), /*#__PURE__*/_react.default.createElement("ul", {
        className: "my-announcements"
      }, !!slicedInbox.length ? slicedInbox.map(function (annc) {
        var isUserAdmin = annc.accessors.find(function (accessor) {
          return accessor.userRef && accessor.userRef._id === user._id && accessor.type !== 'viewer';
        });
        var anncStatusClasses = (0, _classnames.default)({
          'announcement-status': true,
          admin: !!isUserAdmin,
          following: !isUserAdmin
        });
        return /*#__PURE__*/_react.default.createElement("li", {
          key: annc._id,
          className: "my-announcement"
        }, /*#__PURE__*/_react.default.createElement("a", {
          href: "/r/memorial/".concat(annc._id, "?skipMat=true")
        }, /*#__PURE__*/_react.default.createElement(_CharacterProfileImage.default, {
          image: annc.image,
          name: annc.name
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "announcement-details"
        }, /*#__PURE__*/_react.default.createElement("h5", {
          className: "decedent-name"
        }, (0, _utils.nameString)(annc.name)), /*#__PURE__*/_react.default.createElement("span", {
          className: anncStatusClasses
        }, !!isUserAdmin ? 'Admin' : 'Following'))));
      }) : /*#__PURE__*/_react.default.createElement("button", {
        className: "search-button",
        onClick: function onClick() {
          var path = pathname === '/' ? '' : pathname;

          _reactRouter.browserHistory.push("".concat(path, "/memorialsearch"));
        }
      }, "Search")), /*#__PURE__*/_react.default.createElement("ul", {
        className: menuLinksClasses
      }, setMobileMenu && /*#__PURE__*/_react.default.createElement("li", {
        className: "menu-item profile",
        onClick: setMobileMenu(true)
      }, "Profile"), hasCompany && /*#__PURE__*/_react.default.createElement("li", {
        className: "menu-item my-dash"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: "/dash"
      }, "My Dashboard")), /*#__PURE__*/_react.default.createElement("li", {
        className: "menu-item",
        onClick: function onClick() {
          return handleSignOut(true);
        }
      }, "Log Out"))));
    }
  }]);

  return UserWelcome;
}(_react.default.Component);

exports.default = UserWelcome;